/**
 * Those "aggregations" are used inside the summaries data keys to postfix metric ids
 */
var Aggregations;
(function (Aggregations) {
    Aggregations["minimum"] = "N";
    Aggregations["maximum"] = "X";
    Aggregations["latest"] = "L";
    Aggregations["lastSlidingHour"] = "H";
    Aggregations["lastFourHours"] = "4H";
    Aggregations["lastTwelveHours"] = "12H";
    /** From midnight to now */
    Aggregations["today"] = "D";
    Aggregations["yesterday"] = "DD";
    Aggregations["threeDaysAgo"] = "3D";
    Aggregations["fiveDaysAgo"] = "5D";
    Aggregations["week"] = "7D";
    /** Used for frost universe */
    Aggregations["lastValues"] = "LV";
})(Aggregations || (Aggregations = {}));
export const isLastValuesAggregation = (value) => {
    return value === 'LV';
};
export default Aggregations;
